<div class="overflow-x-auto w-full pt-2">
  <table id="tables" class="border-collapse w-full table-auto spacing-0">
    <tr class="bg-red-150/50">
      <th
        *ngFor="let header of headers"
        class="p-2 text-left border border-gray-75 text-black text-xs font-medium h-12"
      >
        {{ header }}
      </th>
    </tr>
    <tr *ngFor="let row of field?.fieldGroup; let index = index">
      <td
        *ngFor="let f of row.fieldGroup"
        class="text-left border border-gray-150 text-black text-xs"
      >
        <formly-field [field]="f"></formly-field>
      </td>
    </tr>
  </table>
</div>
